import React, { useEffect, useState } from "react";
import "./styles.css";
import "../../pages/OrdersHistory/styles.css";
import { Colors } from "../../assets";
import { useRootStore } from "../../stores/rootStoreContext";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { AppDrawer } from "..";
import Select from "react-select";
import WebViewBridge from "../../webViewBridge";
import { OptionTypeBase } from "react-select";

const toDateString = (d: Date) => d.toISOString().split("T")[0];
const today = toDateString(new Date());

const AppHeader = () => {
  const {
    changeOldOrdersFetched,
    changeOrdersFetched,
    removeOrders,
    removeOldOrders,
    isPreparingReset,
    isReadyReset,
    isWaitingReset,
    refusedReset,
    changeOrdersStatusFetched,
    historyFilter,
    historyDateFrom,
    historyDateTo,
    setHistoryFilter,
    setHistoryDateFrom,
    setHistoryDateTo,
  } = useRootStore().rootStore.orderStore;
  const {
    place,
    language,
    setLanguage,
    removePlace,
    setToken,
    changeWSConnected,
  } = useRootStore().rootStore.placeStore;
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(true);
  const { t, i18n } = useTranslation();
  const { currentPage, setCurrentPage } = useRootStore().rootStore.drawerStore;

  const getOrdersHistory = () => {
    setCurrentPage("ordersHistory");
  };

  const getCurrentOrders = () => {
    setCurrentPage("main");
  };

  useEffect(() => {
    //console.log(location.pathname);
    if (location.pathname === "/") setShowHeader(false);
    else setShowHeader(true);
  }, [setShowHeader, location.pathname]);

  const handleSelectOnChange = (option: OptionTypeBase | null) => {
    if (option !== null) {
      setLanguage(option.value);
      if (option.value === "arabic") i18n.changeLanguage("ar");
      if (option.value === "english") i18n.changeLanguage("en");
      if (option.value === "hebrew") i18n.changeLanguage("heb");
      WebViewBridge.getInstance().syncLanguage(i18n.language);
      if (i18n.language !== "en")
        document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
      else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
    }
  };

  const logOut = async (
    e: React.MouseEvent<HTMLParagraphElement, MouseEvent>,
  ) => {
    e.preventDefault();
    WebViewBridge.getInstance().cleanup();
    changeWSConnected(false);
    await localStorage.removeItem("token");
    removeOrders();
    removeOldOrders();
    isPreparingReset();
    isReadyReset();
    isWaitingReset();
    refusedReset();
    changeOldOrdersFetched(false);
    changeOrdersFetched(false);
    changeOrdersStatusFetched(false);
    setToken(null);
    setLanguage("hebrew");
    i18n.changeLanguage("heb");
    document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  };

  if (showHeader)
    return (
      <header className="app-header">
        <div className="app-header-first-row">
          <div
            className="app-header-language-picker"
            style={{
              left: i18n.language === "en" ? 0 : undefined,
              right: i18n.language === "en" ? undefined : 0,
            }}
          >
            <Select
              className="app-header-language-picker"
              style={{
                fontFamily:
                  i18n.language === "ar"
                    ? "'Cairo', sans-serif"
                    : "'Rubik', sans-serif",
              }}
              value={{
                value: language,
                label:
                  language === "arabic"
                    ? "العربية"
                    : language === "hebrew"
                      ? "עברית"
                      : "English",
              }}
              onChange={(option) => handleSelectOnChange(option)}
              options={[
                { value: "hebrew", label: "עברית" },
                { value: "arabic", label: "العربية" },
                { value: "english", label: "English" },
              ]}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  text: Colors.PURPLE,
                  primary25: Colors.GREEN,
                  primary: Colors.PURPLE,
                },
              })}
            />
          </div>
          <AppDrawer />
          {/* <div className="app-header-language-picker">{t("Hebrew")}</div> */}
          {currentPage === "main" ? (
            <h3 style={{ color: Colors.PURPLE, textAlign: "center" }}>
              {t("Current orders")}
            </h3>
          ) : currentPage === "ordersHistory" ? (
            <h3 style={{ color: Colors.PURPLE, textAlign: "center" }}>
              {t("Orders history")}
            </h3>
          ) : (
            <h3
              style={{
                color: Colors.PURPLE,
                textAlign: "center",
                alignSelf: "center",
              }}
            >
              {t("Place page")}
            </h3>
          )}
          <p
            style={{
              right: i18n.language === "en" ? 0 : undefined,
              left: i18n.language === "en" ? undefined : 0,
            }}
            onClick={async (e) => {
              await logOut(e);
              removePlace();
            }}
          >
            {t("Log out")}
          </p>
        </div>
        <div className="app-header-navigation-bar">
          {place !== undefined && place !== null && (
            <Link
              to={`/main`}
              onClick={() => getCurrentOrders()}
              className="app-header-link"
              style={{
                backgroundColor:
                  location.pathname === `/main` ? Colors.GREEN : Colors.PURPLE,
                color:
                  location.pathname === `/main` ? Colors.PURPLE : Colors.GREEN,
              }}
            >
              {t("Current orders")}
            </Link>
          )}
          {place !== undefined && place !== null && (
            <Link
              to={`/orders-history`}
              onClick={() => getOrdersHistory()}
              className="app-header-link"
              style={{
                backgroundColor:
                  location.pathname === `/orders-history`
                    ? Colors.GREEN
                    : Colors.PURPLE,
                color:
                  location.pathname === `/orders-history`
                    ? Colors.PURPLE
                    : Colors.GREEN,
              }}
            >
              {t("Orders history")}
            </Link>
          )}
          {place !== undefined && place !== null && (
            <Link
              to={`/place`}
              className="app-header-link"
              style={{
                backgroundColor:
                  location.pathname === `/place` ? Colors.GREEN : Colors.PURPLE,
                color:
                  location.pathname === `/place` ? Colors.PURPLE : Colors.GREEN,
              }}
              onClick={() => setCurrentPage("placePage")}
            >
              {t("Place page")}
            </Link>
          )}
          {place !== undefined && place !== null && (
            <Link
              to={`/place/budget`}
              className="app-header-link"
              style={{
                backgroundColor:
                  location.pathname === `/place/budget`
                    ? Colors.GREEN
                    : Colors.PURPLE,
                color:
                  location.pathname === `/place/budget`
                    ? Colors.PURPLE
                    : Colors.GREEN,
              }}
              onClick={() => setCurrentPage("budgetPage")}
            >
              {t("Budget")}
            </Link>
          )}
        </div>
        {currentPage !== "" &&
          currentPage !== "placePage" &&
          currentPage !== "budgetPage" && <div className="header-line"></div>}
        {currentPage === "ordersHistory" && (
          <div className="history-filters">
            <div className="history-date-filters">
              <label className="history-date-label">
                {t("From")}
                <input
                  type="date"
                  className="history-date-input"
                  value={historyDateFrom}
                  max={today}
                  onChange={(e) => setHistoryDateFrom(e.target.value)}
                />
              </label>
              <label className="history-date-label">
                {t("To")}
                <input
                  type="date"
                  className="history-date-input"
                  value={historyDateTo}
                  max={today}
                  onChange={(e) => setHistoryDateTo(e.target.value)}
                />
              </label>
            </div>
            <div className="history-status-filters">
              <button
                className={`history-filter-btn ${historyFilter === "all" ? "history-filter-btn--active" : ""}`}
                onClick={() => setHistoryFilter("all")}
              >
                {t("All")}
              </button>
              <button
                className={`history-filter-btn history-filter-btn--done ${historyFilter === "done" ? "history-filter-btn--active" : ""}`}
                onClick={() => setHistoryFilter("done")}
              >
                {t("Done")}
              </button>
              <button
                className={`history-filter-btn history-filter-btn--cancelled ${historyFilter === "cancelled" ? "history-filter-btn--active" : ""}`}
                onClick={() => setHistoryFilter("cancelled")}
              >
                {t("Cancelled")}
              </button>
            </div>
          </div>
        )}
      </header>
    );
  else return <div></div>;
};

export default observer(AppHeader);
